import Post from '@/libs/request/post'
const baseUrl = window.location.origin + window.location.pathname
function initSDK (res) {
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: res.data.appId,
    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
    signature: res.data.signature, // 必填，签名
    jsApiList: [
      'updateAppMessageShareData',
      'updateTimelineShareData',
    ]// 必填，需要使用的JS接口列表
  })
  wx.ready(function () {
    updateShareData('/Home')
  })
}
function chechare () {
  function getQueryString (name) { // 根据字段看网址是否拼接&字符串
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) { return unescape(r[2]) }
    return null
  }
  var from = getQueryString('from')
  var appinstall = getQueryString('appinstall')
  var sec = getQueryString('sec')
  var timekey = getQueryString('timekey')

  if (from || appinstall || sec || timekey) { // 假如拼接上了
    window.location.href = window.location.origin + window.location.pathname
  }
}
export function updateShareData(route) {
  route = route !== '/Home' ? '#' + route : ''
  const data =  {
    title: '律家保-您的私人律师！', // 分享标题
    desc: '30秒接通专业律师。先咨询，后付费！', // 分享描述
    link: baseUrl + route, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    // 该链接是重定向链接，因为需要获取用户code，但是该链接又无法直接写微信获取code的链接，
    // 所以需要点击后重新加载新的页面，来实现重定向，重新打开获取code的微信链接，实现获取用户信息的功能；
    imgUrl: 'https://cdn.51ljb.cn/ljb-logo-pic.png', // 分享图标
  }
  wx.updateAppMessageShareData(data)
  wx.updateTimelineShareData(data)
}
// 分享可口
export default function() {
  chechare()
  Post.wxShare({
    url: encodeURIComponent(location.href.split('#')[0])
  }).then((res) => {
    initSDK(res)
  })
}



// WEBPACK FOOTER //
// ./src/libs/utils/wxShare.js